import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { FiSave } from "react-icons/fi";
import toast from "react-hot-toast";

export default function AdminContact() {
    const [form, setForm] = useState({
        email: "", phone: "", address: "", inquiryNote: "",
        instagram: "", facebook: "", tiktok: "", goodreads: "",
        emailjsServiceId: "", emailjsTemplateId: "", emailjsPublicKey: "",
        showForm: true
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        async function load() {
            try {
                const snap = await getDoc(doc(db, "siteConfig", "contact"));
                if (snap.exists()) setForm(snap.data());
            } catch {
                toast.error("Could not load contact info.");
            }
            setLoading(false);
        }
        load();
    }, []);

    function handleChange(e) {
        const { name, value, type, checked } = e.target;
        setForm(f => ({ ...f, [name]: type === "checkbox" ? checked : value }));
    }

    async function save() {
        setSaving(true);
        try {
            await setDoc(doc(db, "siteConfig", "contact"), form);
            toast.success("Contact info saved!");
        } catch {
            toast.error("Failed to save.");
        }
        setSaving(false);
    }

    if (loading) return <div className="admin-loading">Loading…</div>;

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 24 }}>
                <button className="admin-btn-primary" onClick={save} disabled={saving}>
                    <FiSave size={16} /> {saving ? "Saving…" : "Save Changes"}
                </button>
            </div>

            <div className="admin-card" style={{ padding: 28 }}>
                <div className="admin-form">
                    <div className="admin-form-grid">
                        <div className="admin-form-field">
                            <label>Contact Email</label>
                            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="hello@lbbooks.com" />
                        </div>
                        <div className="admin-form-field">
                            <label>Phone Number</label>
                            <input name="phone" value={form.phone} onChange={handleChange} placeholder="+1 (787) 000-0000" />
                        </div>
                        <div className="admin-form-field full">
                            <label>Business Address</label>
                            <input name="address" value={form.address} onChange={handleChange} placeholder="San Juan, Puerto Rico" />
                        </div>
                        <div className="admin-form-field full">
                            <label>Inquiry Note (shown above the contact form)</label>
                            <textarea name="inquiryNote" value={form.inquiryNote} onChange={handleChange}
                                placeholder="For press, wholesale, or signed copy requests, reach out below…"
                                rows={4} />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <p style={{ fontSize: 12, fontWeight: 700, textTransform: "uppercase", color: "#888", letterSpacing: 0.5, marginBottom: 16 }}>Social Links</p>
                        </div>
                        <div className="admin-form-field">
                            <label>Instagram URL</label>
                            <input name="instagram" value={form.instagram} onChange={handleChange} placeholder="https://instagram.com/lilizblack/" />
                        </div>
                        <div className="admin-form-field">
                            <label>Facebook URL</label>
                            <input name="facebook" value={form.facebook} onChange={handleChange} placeholder="https://facebook.com/LBLilizBlack" />
                        </div>
                        <div className="admin-form-field">
                            <label>TikTok URL</label>
                            <input name="tiktok" value={form.tiktok} onChange={handleChange} placeholder="https://tiktok.com/@liliz.black" />
                        </div>
                        <div className="admin-form-field">
                            <label>Goodreads URL</label>
                            <input name="goodreads" value={form.goodreads} onChange={handleChange} placeholder="https://www.goodreads.com/author/..." />
                        </div>

                        <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                            <p style={{ fontSize: 12, fontWeight: 700, textTransform: "uppercase", color: "#888", letterSpacing: 0.5, marginBottom: 8 }}>EmailJS Configuration (Contact Form)</p>
                            <p style={{ fontSize: 12, color: "#aaa", marginBottom: 16 }}>These keys allow your contact form to send emails to your inbox.</p>
                        </div>

                        <div className="admin-form-field">
                            <label>Service ID</label>
                            <input name="emailjsServiceId" value={form.emailjsServiceId} onChange={handleChange} placeholder="service_xxxxxx" />
                        </div>
                        <div className="admin-form-field">
                            <label>Template ID</label>
                            <input name="emailjsTemplateId" value={form.emailjsTemplateId} onChange={handleChange} placeholder="template_xxxxxx" />
                        </div>
                        <div className="admin-form-field">
                            <label>Public Key</label>
                            <input name="emailjsPublicKey" value={form.emailjsPublicKey} onChange={handleChange} placeholder="user_xxxxxx or Public Key" />
                        </div>

                        <div className="admin-form-field" style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
                            <input type="checkbox" name="showForm" id="showForm" checked={form.showForm} onChange={handleChange} style={{ width: 16, height: 16 }} />
                            <label htmlFor="showForm" style={{ cursor: "pointer" }}>Show contact form on page</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
